import request from "@/apis/index";
import { CommonListParams } from "@/types/common";
import {
  ShipAddress,
  ShipAddressParams,
  ShipAddressType,
  ShipAddressTypeOption,
} from "@/types/shipAddress";

const url = "/wms/customer";

const api = {
  types: `${url}/shipAddress/type/types`,
  list: (customerId: string) => `${url}/${customerId}/shipAddress/list`,
  typeList: (customerId: string, type: ShipAddressType) => `${url}/${customerId}/type/${type}/shipAddress/list`,
  get: (id: string) => `${url}/shipAddress/${id}/get`,
  fetch: (id: string) => `${url}/shipAddress/${id}/fetch`,
  add: (customerId: string) => `${url}/${customerId}/shipAddress/add`,
  update: (id: string) => `${url}/shipAddress/${id}/update`,
  del: (id: string) => `${url}/shipAddress/${id}/del`,
  setDefault: (id: string) => `${url}/shipAddress/${id}/setDefault`,
};

const listPath = (customerId: string, type?: ShipAddressType) =>
  type === undefined
    ? api.list(customerId)
    : api.typeList(customerId, type);

export const types = () => request<ShipAddressTypeOption[]>(api.types).then(({ body }) => body).catch((err) => Promise.reject(err));

export const list = (
  customerId: string,
  type?: ShipAddressType,
  params?: CommonListParams<string>,
) =>
  request<Array<ShipAddress>, string>(listPath(customerId, type), { params })
    .then(({ body, pagination }) => ({ body, pagination }))
    .catch((err) => Promise.reject(err));

export const get = (id: string) =>
  request<ShipAddress>(api.get(id))
    .then(({ body }) => body)
    .catch((err) => Promise.reject(err));

export const fetch = (id: string) =>
  request<ShipAddress>(api.fetch(id))
    .then(({ body }) => body)
    .catch((err) => Promise.reject(err));

export const add = (customerId: string, body: ShipAddressParams) =>
  request<ShipAddress, ShipAddressParams>(api.add(customerId), {
    params: { body },
  })
    .then(({ body: result }) => result)
    .catch((err) => Promise.reject(err));

export const update = (id: string, body: ShipAddressParams) =>
  request<ShipAddress, ShipAddressParams>(api.update(id), {
    params: { body },
  })
    .then(({ body: result }) => result)
    .catch((err) => Promise.reject(err));

export const del = (id: string) =>
  new Promise<void>((resolve, reject) => {
    request<void>(api.del(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  });

export const setDefault = (id: string) =>
  new Promise<void>((resolve, reject) => {
    request<void>(api.setDefault(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  });

const shipAddressApi = {
  types,
  list,
  get,
  fetch,
  add,
  update,
  del,
  setDefault,
};

export default shipAddressApi;
